
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25 0C11.193 0 0 11.193 0 25s11.193 25 25 25 25-11.193 25-25S38.807 0 25 0z"}}),_c('path',{attrs:{"d":"M33.248 26.343l-12.8 7.916a1.613 1.613 0 01-1.624.042A1.58 1.58 0 0118 32.917V17.084c0-.576.316-1.106.824-1.385a1.61 1.61 0 011.624.042l12.8 7.917c.468.29.752.797.752 1.342a1.58 1.58 0 01-.752 1.343z","fill":"currentColor"}})])
          )
        }
      }
    